import { render } from "./GREEN_logo.vue?vue&type=template&id=47266804&scoped=true"
import script from "./GREEN_logo.vue?vue&type=script&lang=js"
export * from "./GREEN_logo.vue?vue&type=script&lang=js"

import "./GREEN_logo.vue?vue&type=style&index=0&id=47266804&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47266804"]])

export default __exports__